import './report-download.scss';
import { useQuery } from 'hooks/query';
import { useHistory } from 'react-router-dom';

function ReportDownloadOld() {
    let query = useQuery();
    const history = useHistory();
    // For old / legacy links to download reports from the old App, redirects to new route
    history.push(`/report/1/${query.get("fileName") ? query.get("fileName") : "not-found"}`);

    return (
        <div id={'report-download'} className={'container'}>
            <i className="fal fa-spinner fa-spin fa-5x"></i>
        </div>
    )
}

export default ReportDownloadOld;
